import { Bot, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const DemoSection = () => {
  return (
    <section className="py-20 bg-blue-950">
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-900 to-blue-800 p-8 md:p-12">
          <div className="absolute inset-0 bg-grid-white/5" />
          
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-white">
                Ready to Experience the Future?
              </h2>
              <p className="text-lg text-blue-200">
                Book a personalized demo to see how our AI agents and chatbots can 
                transform your business operations and customer experience.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact">
                  <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50 w-full sm:w-auto">
                    Schedule Demo
                  </Button>
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 rounded-xl bg-blue-900/50 border border-blue-700/50 backdrop-blur-sm">
                <Bot className="h-8 w-8 text-blue-300 mb-2" />
                <h3 className="text-lg font-semibold text-white mb-1">
                  AI Agents
                </h3>
                <p className="text-blue-200 text-sm">
                  Intelligent automation for your business processes
                </p>
              </div>
              <div className="p-4 rounded-xl bg-blue-900/50 border border-blue-700/50 backdrop-blur-sm">
                <MessageSquare className="h-8 w-8 text-blue-300 mb-2" />
                <h3 className="text-lg font-semibold text-white mb-1">
                  Chatbots
                </h3>
                <p className="text-blue-200 text-sm">
                  24/7 customer support and engagement
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};